<template>
    <div class="app">
        <SignInPC v-if="isPC" />
        <SignInH5 v-else />
    </div>
</template>
<script>
    import SignInH5 from '../components/h5';
    import SignInPC from '../components/pc';
    import { enableAppShare } from '../../../common/js/APP/share';
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC
        },
        data() {
            return {};
        },
        mounted() {
            enableAppShare({
                title: '告别无效学习！挑战 UI 大厂高薪',
                desc: '90天构建完整技能体系，蜕变高阶UI设计师',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20210806/1628230034571.png',
            });
        }
    };
</script>
<style lang="less" scoped>
    .app {
        overflow-x: hidden;
    }
</style>
